import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Import Swiper styles
import "swiper/css/navigation"; // Optional: for navigation buttons
import "swiper/css/pagination"; // Optional: for pagination

import atbeo from "../../../assets/images/HomeTeamOfExpertTab/atbeo.webp";
import ahung from "../../../assets/images/HomeTeamOfExpertTab/ahung.webp";
import abach from "../../../assets/images/HomeTeamOfExpertTab/abach.webp";
import atuan1 from "../../../assets/images/HomeTeamOfExpertTab/atuan1.webp";
import ason from "../../../assets/images/HomeTeamOfExpertTab/ason.webp";
import cnhung from "../../../assets/images/HomeTeamOfExpertTab/cnhung.webp";
import ctrang from "../../../assets/images/HomeTeamOfExpertTab/ctrang.webp";
import attao from "../../../assets/images/HomeTeamOfExpertTab/attao.webp";

export default function HomeTeamOfExpertTab() {
  const [activeTab, setActiveTab] = useState(0);

  const profiles = [
    {
      src: atuan1,
      name: "Trần Anh Tuấn",
      title: "Chủ tịch, CEO & Founder",
      categories: ["leader"],
    },
    {
      src: abach,
      name: "Trần Văn Bạch",
      title: "Phó tổng giám đốc, Co-Founder",
      categories: ["leader", "it"], // Phân vào 2 nhóm
    },
    {
      src: atbeo,
      name: "Phạm Anh Tuấn",
      title: "Giám đốc kĩ thuật, Co-Founder",
      categories: ["it", "leader"], // Phân vào 2 nhóm
    },
    {
      src: ason,
      name: "Ngô Hoàng Sơn",
      title: "Giám đốc kĩ thuật, Co-Founder",
      categories: ["it", "leader"], // Phân vào 2 nhóm
    },
    {
      src: ahung,
      name: "Phạm Thế Hùng",
      title: "Chuyên gia giáo dục",
      categories: ["advisor"],
    },
    {
      src: cnhung,
      name: "Nguyễn Thị Nhung",
      title: "Chuyên gia giáo dục",
      categories: ["advisor"],
    },
    {
      src: ctrang,
      name: "Nguyễn Thu Trang",
      title: "Chuyên gia giáo dục",
      categories: ["advisor"],
    },
    {
      src: attao,
      name: "Nguyễn Bá Thảo",
      title: "Trưởng phòng Marketing",
      categories: ["marketing"],
    },
  ];

  const filteredProfiles =
    activeTab === 0
      ? profiles
      : profiles.filter((profile) =>
          profile.categories.includes(
            activeTab === 1
              ? "leader"
              : activeTab === 2
              ? "it"
              : activeTab === 3
              ? "advisor"
              : "marketing"
          )
        );

  return (
    <div className="w-full mx-auto cursor-pointer">
      <div className="mt-4">
        <div className="block md:hidden w-full">
          <Swiper spaceBetween={10} slidesPerView={2}>
            {filteredProfiles.map((profile, index) => (
              <SwiperSlide key={index}>
                <div className="flex flex-col border items-center justify-center text-center border-solid border-[#E2E2E2] w-full shadow-custom-light rounded-[16px] px-[24px] py-[30px]">
                  <img
                    src={profile.src}
                    alt={profile.name}
                    className="w-full h-auto object-cover"
                  />
                  <div className="w-full h-[130px]">
                    <h3 className="mt-2 text-lg font-semibold">
                      {profile.name}
                    </h3>
                    <p className="text-gray-600">{profile.title}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="hidden md:grid grid-cols-4 gap-4">
          {filteredProfiles.map((profile, index) => (
            <div
              key={index}
              className="flex flex-col hover:border hover:border-blue-500 items-center border-solid border-[#E2E2E2] w-full shadow-custom-light rounded-[16px] px-[24px] py-[30px]"
            >
              <img
                src={profile.src}
                alt={profile.name}
                className="w-[50%] h-auto object-cover"
              />
              <h3 className="mt-2 text-lg font-semibold text-center">
                {profile.name}
              </h3>
              <p className="text-gray-600 text-center">{profile.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
